import React, { useEffect } from 'react';
import { FullPageLoader } from '../components/PageWrapper';
import { Box, Button, Container, Typography } from '@mui/material';
import useAuth, { useAuthEffects } from '../components/Auth';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from '../hooks';
import { selectMyCompany } from './accountSlice';
import { useThemeContext } from '../ThemeProvider';

export const SignUpHandler = () => {
	const { isAuthenticated, isAuthLoading, loginWithRedirect } = useAuth();
	const { type } = useParams();
	const navigate = useNavigate();
	useEffect(() => {
		if (isAuthenticated || !type || !['creator', 'vendor'].includes(type)) {
			navigate('/');
		}
		if (!isAuthenticated) {
			loginWithRedirect({
				authorizationParams: {
					redirect_uri: window.location.origin + '/setup-account/' + type
				}
			});
		}
	}, [isAuthenticated, isAuthLoading, type]);
	return null;
};

export const SetupAccountListener = () => {
	const { isAuthenticated } = useAuth();
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const myCompany = useAppSelector(selectMyCompany);

	useEffect(() => {
		// if (myCompany && myCompany.roleVendor) {
		// 	navigate('/');
		// 	return;
		// }
		if (!pathname.includes('/setup-account') && myCompany && !myCompany.roleCustomer && !myCompany.roleCreator && !myCompany.roleVendor) {
			navigate('/setup-account');
		}
	}, [isAuthenticated, myCompany]);
	return null;
};

export const SetupAccountLayout = ({ children }: { children: React.ReactNode }) => {
	const {t} = useTranslation();
	const {isDarkModeOn} = useThemeContext();
	return <Box sx={{display:'flex', flexDirection: 'column', minHeight: '100dvh'}}>
		<Box flex={1} display='flex' justifyContent='center' alignItems='center'>
			<Container maxWidth='sm'>
				<Box sx={{flex: 1}}>
					<Box textAlign='center' pt={6}>
						{isDarkModeOn ? <img src='/logo-dark.svg' alt='DIYFeed' width={100} height={100} /> : <img src='/logo-main.svg' alt='DIYFeed' width={100} height={100} />}
					</Box>
					<Typography variant='h1' textAlign='center' fontSize='4rem' py={4}>{t('signUp.title')}</Typography>
					{children}
				</Box>
			</Container>
		</Box>
	</Box>;
};

export const SetupAccount = () => {
	useAuthEffects();
	const {isAuthenticated, isAuthLoading, logout} = useAuth();
	const myCompany = useAppSelector(selectMyCompany);
	const navigate = useNavigate();

	// redirect to home if user is not authenticated
	useEffect(() => {
		if (!isAuthenticated && !isAuthLoading) {
			navigate('/');
		}
	}, [isAuthenticated, isAuthLoading]);

	// redirect to home if user has a role set up already
	useEffect(() => {
		if (myCompany && (myCompany.roleCustomer || myCompany.roleCreator || myCompany.roleVendor)) {
			navigate('/');
		}
	}, [myCompany]);

	if (!isAuthenticated || isAuthLoading) {
		return <FullPageLoader loadingMessage='Loading user profile...' />;
	}
	return <SetupAccountLayout>
		<Box display='flex' flexDirection='column' gap={2}>
			<Typography variant='body1' textAlign='center' py={2}>Quick-start your account:</Typography>
			<Button size='large' variant='contained' component={RouterLink} to='/setup-account/creator' sx={{textTransform: 'none', py: 4}}>I build things</Button>
			<Button size='large' variant='contained' component={RouterLink} to='/setup-account/vendor' sx={{textTransform: 'none', py: 4}}>I sell materials</Button>
		</Box>
		<Box py={4} textAlign='center'>
			<Button onClick={() => logout()}>Log out</Button>
		</Box>
	</SetupAccountLayout>;
};
